<template>
    <div>
        <section class="page-section">
            <h5>Constraints</h5>
            <div class="constraint-container" v-if="!!Object.keys(constrainedItem).length && constrainedItem.timeConstraints">
                <TimeConstraintItem
                        v-for="cstr in constrainedItem.timeConstraints"
                        :key="cstr.uid"
                        :originalConstraint="cstr"
                        :allow-date-selection="allowDateSelection"
                        :allow-day-of-week-selection="allowDayOfWeekSelection"
                        :allow-day-of-month-selection="allowDayOfMonthSelection"
                        :allow-period-selection="allowPeriodSelection"
                        @onDeleted="onConstraintDeleted"
                        @onUpdated="onConstraintUpdated"
                ></TimeConstraintItem>
            </div>
        </section>
        <section class="page-section" v-if="viewState.showNewPanel">
            <div>
                <h5>New constraint</h5>
                <TimeConstraintItem
                        v-if="!!Object.keys(constrainedItem).length"
                        :originalConstraint="null"
                        :parentUid="constrainedItem.uid"
                        :typeId="timeConstraintType"
                        :createMode="true"
                        :allow-date-selection="allowDateSelection"
                        :allow-day-of-week-selection="allowDayOfWeekSelection"
                        :allow-day-of-month-selection="allowDayOfMonthSelection"
                        :allow-period-selection="allowPeriodSelection"
                        @onCancel="onCancel"
                        @onCreated="onConstraintCreated"
                ></TimeConstraintItem>
            </div>
        </section>

        <section class="page-section actions" v-else>
            <button class="add-cst" @click.prevent="viewState.showNewPanel=true">
                <i data-v-3ed9b467 class="fas fa-plus"></i>
                Add Constraint
            </button>
        </section>
    </div>
</template>
<script>
    //import { mapState, mapMutation } from "vuex";
    import TimeConstraintItem from "@/components/common/TimeConstraintItem";
    // import TimeConstraintApis from "@/apis/_apiTimeConstraints";
    export default {
        components: {TimeConstraintItem},
    //  computed: {
    //  ...mapState(["currentBox"])
    //},
        props: {
          constrainedItem: {type: Object, required: true},
          timeConstraintType: {type: Number, required: true},
          allowDateSelection: {type: Boolean, default: true},
          allowDayOfWeekSelection: {type: Boolean, default: true},
          allowDayOfMonthSelection: {type: Boolean, default: true},
          allowPeriodSelection: {type: Boolean, default: true}
        },
        data() {
            return {
                viewState: {
                    showNewPanel: false
                },
            };
        },
        methods: {
            onCancel() {
                this.viewState.showNewPanel = false;
            },
            onConstraintUpdated(constraint) {
                var updatedCstr = (this.constrainedItem.timeConstraints || []).find(function (
                    cstr
                ) {
                    return cstr.uid === constraint.uid;
                });
                if (updatedCstr) {
                    Object.assign(updatedCstr, constraint);
                }
            },
            onConstraintCreated(cstr) {
                (this.constrainedItem.timeConstraints || []).push(cstr);
            },
            onConstraintDeleted(deletedCstr) {
                var idx = (this.constrainedItem.timeConstraints || []).findIndex(function (
                    cstr
                ) {
                    return cstr.uid === deletedCstr.uid;
                });
                console.log(idx, deletedCstr);
                if (idx >= 0) {
                    (this.constrainedItem.timeConstraints || []).splice(idx, 1);
                }
            }
        }
    };
</script>
<style scoped>
    div.actions {
        position: sticky;
        top: 0;
        background: white;
        padding: 15px;
        z-index: 600;
    }

    section.actions::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: var(--COLOR_BORDERS);
    }

    .constraint-container {
        margin-bottom: 15px;
    }

    .add-cst {
        color: var(--COLOR_BRAND);
        background: none;
    }
</style>